import React from 'react';
import { Button } from 'reactstrap';
import { PropertiesList } from '../../models/propertyModel';

interface Props {
  property: PropertiesList;
  setOwnerProperty: (property: PropertiesList) => void;
  setOwnerModalOpen: (open: boolean) => void;
}

const PropertyOwnerDetail: React.FC<Props> = ({ property, setOwnerProperty, setOwnerModalOpen }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{
        fontWeight: 700,
        fontSize: 14,
        color: '#6c757d',
        letterSpacing: 1,
        marginRight: 4,
      }}>
        PROPIETARIO
      </span>
      {/* Línea vertical */}
      <span style={{
        display: 'inline-block',
        width: 1,
        height: 22,
        background: '#e0e0e0',
        margin: '0 8px',
        verticalAlign: 'middle',
      }} />
      <span style={{
        fontWeight: 500,
        fontSize: 15,
        color: '#343a40',
      }}>
        {property.landlordInfo?.first_name || ''} {property.landlordInfo?.last_name || ''}
      </span>
      <Button
        size="sm"
        color="primary"
        outline
        style={{
          borderRadius: 12,
          padding: '2px 10px',
          fontSize: 13,
          boxShadow: '0 1px 4px 0 rgba(44,62,80,0.06)',
          background: '#f4f6fa',
          border: '1px solid #5e72e4',
          color: '#5e72e4',
          marginLeft: 8,
        }}
        className="edit-btn"
        title="Editar propietario"
        onClick={() => {
          setOwnerProperty(property);
          setOwnerModalOpen(true);
        }}
      >
        <i className="fas fa-edit" />
      </Button>
    </div>
    {property.landlordInfo?.phone && (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 2 }}>
        <i className="fas fa-phone" style={{ fontSize: 15, color: '#6c757d' }} />
        <span style={{ color: '#6c757d', fontSize: 15 }}>
          {property.landlordInfo?.area_code ? `${property.landlordInfo.area_code} ` : ''}
          {property.landlordInfo?.phone}
        </span>
      </div>
    )}
    {property.landlordInfo?.email && (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 2 }}>
        <i className="fas fa-envelope" style={{ fontSize: 15, color: '#6c757d' }} />
        <span style={{ color: '#6c757d', fontSize: 15 }}>
          {property.landlordInfo?.email}
        </span>
      </div>
    )}
  </div>
);

export default PropertyOwnerDetail;